import React from "react";
import Lucide from "src/base-components/Lucide";
// import Lucide from "src/base-components/Lucide";

interface ScrollToBottomButtonProps {
  visible: boolean;
  onClick: () => void;
  className?: string;
  iconSize?: number;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  visible,
  onClick,
  className = "",
  iconSize = 5,
}) => {
  if (!visible) return null;

  return (
    <button
      onClick={onClick}
      className={`absolute bottom-4 right-4 z-[21] w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors border border-gray-200 ${className}`}
    >
      <Lucide icon="ChevronDown" className={`w-${iconSize} h-${iconSize} text-gray-600`} />
    </button>
  );
};

export default ScrollToBottomButton;
